(() => {
  const push = (event, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  };

  const init = (root) => {
    if (!root || root.dataset.tasteReady) return;
    root.dataset.tasteReady = '1';

    const rail = root.querySelector('[data-taste-rail]');
    const cards = [...root.querySelectorAll('[data-taste-card]')];
    const modal = root.querySelector('[data-taste-modal]');
    const progress = root.querySelector('[data-taste-progress]');
    let items = [];

    try {
      items = JSON.parse(root.querySelector('[data-taste-items]').textContent);
    } catch (error) {
      items = [];
    }

    let index = 0;
    let returnFocus = null;

    progress.innerHTML = items.map(() => '<i><b></b></i>').join('');

    const updateProgress = (percent = 0) => {
      [...progress.children].forEach((bar, barIndex) => {
        const fill = bar.querySelector('b');
        if (!fill) return;
        if (barIndex < index) fill.style.width = '100%';
        else if (barIndex > index) fill.style.width = '0%';
        else fill.style.width = `${Math.max(0, Math.min(100, percent))}%`;
      });
    };

    const close = () => {
      modal.querySelector('video')?.pause();
      modal.hidden = true;
      document.body.style.overflow = '';
      returnFocus?.focus();
    };

    const render = (next) => {
      if (!items.length) return;

      index = (next + items.length) % items.length;
      const item = items[index];
      const wrap = root.querySelector('[data-taste-video-wrap]');
      wrap.innerHTML = '';
      updateProgress(0);

      if (item.video) {
        const video = document.createElement('video');
        video.src = item.video;
        video.playsInline = true;
        video.autoplay = true;
        video.muted = true;
        video.preload = 'metadata';

        video.addEventListener('timeupdate', () => {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          updateProgress((video.currentTime / video.duration) * 100);
        });

        video.addEventListener('ended', () => {
          updateProgress(100);
          push('digi_awareness_taste_completed', {
            taste_story: item.title,
            taste_index: index + 1
          });

          if (index < items.length - 1) render(index + 1);
          else close();
        });

        wrap.append(video);
        video.play().catch(() => {});
      }

      root.querySelector('[data-taste-title]').textContent = item.title;
      root.querySelector('[data-taste-badge]').textContent = item.badge;
      root.querySelector('[data-taste-text]').textContent = item.text;

      const link = root.querySelector('[data-taste-product]');
      link.hidden = !item.productUrl;
      link.href = item.productUrl || '#';
      link.onclick = () => push('digi_awareness_taste_product_click', {
        taste_story: item.title
      });

      const liked = localStorage.getItem(`digi-taste-${item.id}`) === '1';
      const likeButton = root.querySelector('[data-taste-like]');
      likeButton.classList.toggle('is-liked', liked);
      likeButton.textContent = liked ? '♥' : '♡';

      const soundButton = root.querySelector('[data-taste-sound]');
      soundButton.textContent = 'Som';

      push('digi_awareness_taste_open', {
        taste_story: item.title,
        taste_index: index + 1
      });
    };

    const open = (cardIndex) => {
      returnFocus = cards[cardIndex]?.querySelector('button');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      render(cardIndex);
      root.querySelector('[data-taste-close]').focus();
    };

    cards.forEach((card, cardIndex) => {
      card.querySelector('[data-taste-open]').addEventListener('click', () => open(cardIndex));
    });

    root.querySelectorAll('[data-taste-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    root.querySelector('[data-taste-modal-prev]').addEventListener('click', () => render(index - 1));
    root.querySelector('[data-taste-modal-next]').addEventListener('click', () => render(index + 1));

    root.querySelector('[data-taste-sound]').addEventListener('click', (event) => {
      const video = modal.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      event.currentTarget.textContent = video.muted ? 'Som' : 'Sem som';
    });

    root.querySelector('[data-taste-like]').addEventListener('click', (event) => {
      const item = items[index];
      const liked = localStorage.getItem(`digi-taste-${item.id}`) === '1';
      localStorage.setItem(`digi-taste-${item.id}`, liked ? '0' : '1');
      event.currentTarget.classList.toggle('is-liked', !liked);
      event.currentTarget.textContent = !liked ? '♥' : '♡';
      push('digi_awareness_taste_like', {
        taste_story: item.title,
        taste_liked: !liked
      });
    });

    root.querySelector('[data-taste-share]').addEventListener('click', async () => {
      const item = items[index];
      const data = { title: item.title, url: location.href };
      if (navigator.share) await navigator.share(data).catch(() => {});
      else await navigator.clipboard?.writeText(location.href);
      push('digi_awareness_taste_share', { taste_story: item.title });
    });

    root.querySelector('[data-taste-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -360, behavior: 'smooth' });
    });

    root.querySelector('[data-taste-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: 360, behavior: 'smooth' });
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') render(index - 1);
      if (event.key === 'ArrowRight') render(index + 1);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-digi-awareness-taste]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
